import { render, staticRenderFns } from "./UserAddressSidebar.vue?vue&type=template&id=f33dd342"
import script from "./UserAddressSidebar.vue?vue&type=script&lang=js"
export * from "./UserAddressSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserAddressSidebar.vue?vue&type=style&index=0&id=f33dd342&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports